import React from 'react';
import { connect } from 'react-redux';
import { Box } from '@mui/material';

import { State as RootState } from '@occc-app/rootRedux';
import { FormInput, FormInputProps } from '@occc-app/Offer/components/FormInput';

import { actions, State } from './redux';

import { urlValidation, withFormEventValidation } from '../validatableComponent';
import { FormTextarea } from '../FormTextarea';

const marketingContentFields = [
  {
    name: 'title',
    title: 'Title',
    inputType: 'text',
  },
  {
    name: 'imageUrl',
    title: 'Image URL',
    inputType: 'text',
  },
  {
    name: 'shortDescription',
    title: 'Short Description',
    inputType: 'text',
  },
  {
    name: 'longDescription',
    title: 'Long Description',
    inputType: 'textarea',
  },
  {
    name: 'termsUrl',
    title: 'Terms URL',
    inputType: 'url',
  },
  {
    name: 'terms',
    title: 'Terms',
    inputType: 'textarea',
  },
  {
    name: 'disclaimerUrl',
    title: 'Disclaimer URL',
    inputType: 'url',
  },
  {
    name: 'disclaimer',
    title: 'Disclaimer',
    inputType: 'textarea',
  },
];

type UrlValidateWith = Pick<State, 'disclaimerUrl' | 'termsUrl'>;

const UrlInput = withFormEventValidation<FormInputProps, UrlValidateWith>(FormInput, urlValidation);

type Actions = typeof actions;
type Props = State & Actions;
class MarketingContent extends React.Component<Props, {}> {
  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.props.marketingContentUpdate(event.currentTarget.id, event.currentTarget.value);
  };

  renderMarketingContentFields() {
    return marketingContentFields.map((marketingContentField) => {
      const { name, title, inputType } = marketingContentField;
      const value = (this.props as any)[name];

      switch (inputType) {
        case 'textarea':
          return (
            <FormTextarea
              key={name}
              id={name}
              label={title}
              onChange={this.handleChange}
              value={value}
              rows='5'
            />
          );
        case 'text':
          return (
            <FormInput
              key={name}
              id={name}
              label={title}
              onChange={this.handleChange}
              type='text'
              value={value}
            />
          );
        default:
          return (
            <UrlInput
              key={name}
              id={name}
              label={title}
              onChange={this.handleChange}
              type='text'
              value={value}
            />
          );
      }
    });
  }

  render() {
    return <Box width={[1, 3 / 4]}>{this.renderMarketingContentFields()}</Box>;
  }
}

type MapStateToProps = (state: RootState) => State;
const mapStateToProps: MapStateToProps = ({ offer: { marketingContent } }) => marketingContent;
export default connect(mapStateToProps, actions)(MarketingContent);
